import { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { AppContext } from '../context/AppContext'
import DragDrop from '../reusable/DragDrop'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'
import { staticUrl } from '../utils/url'

const AddTestimonial = ({
  isModal,
  setModal,
  isEdit,
  setEdit,
  setTestimonialData,
  testimonialData,
  getTestimonials,
}) => {
  // ! context
  const { setAlert } = useContext(AppContext)

  // ! hooks
  const [isSubmitting, setSubmitting] = useState(false)
  const [inputData, setInputData] = useState({
    username: '',
    company: '',
    description: '',
    status: false,
  })
  const [avatar, setAvatar] = useState()
  useEffect(() => {
    testimonialData &&
      setInputData({
        username: testimonialData?.username || '',
        company: testimonialData?.company || '',
        description: testimonialData?.description || '',
        status: testimonialData?.status,
        avatar: testimonialData?.avatar || '',
      })
    testimonialData?.avatar &&
      setAvatar({ preview: staticUrl + testimonialData?.avatar || '' })
  }, [testimonialData])

  // ! get input value
  const handleChange = ({ target }) => {
    const { name, value, checked, type, files } = target
    if (type === 'file') {
      setAvatar({
        name: files?.[0]?.name,
        size: files?.[0]?.size,
        preview: URL.createObjectURL(files?.[0]),
        file: files?.[0],
      })
    } else {
      setInputData({
        ...inputData,
        [name]: name === 'status' ? checked : value,
      })
    }
  }

  // ! send data into the server
  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    try {
      const formData = new FormData()
      for (let field in inputData) formData.append(field, inputData[field])
      avatar?.file && formData.append('avatar', avatar?.file)
      if (isEdit) {
        const { data } = await fetchData.patch(
          `/testimonial/${testimonialData?._id}`,
          formData,
          { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
        )
        setAlert({
          show: true,
          variant: 'success',
          message: 'Testimonial successfully updated',
          icon: 'mdi mdi-check',
          duration: 5,
        })
      } else {
        const { data } = await fetchData.post('/testimonial', formData, {
          headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` },
        })
        setAlert({
          show: true,
          variant: 'success',
          message: 'Testimonial successfully added',
          icon: 'mdi mdi-check',
          duration: 5,
        })
      }
      getTestimonials()
      hideModal()
    } catch (error) {
      console.log({ ...error }, error)
      setAlert({
        show: true,
        variant: 'danger',
        message:
          error?.response?.data?.message ||
          'Something went wrong. Please try again.',
        icon: 'mdi mdi-close',
        duration: 5,
      })
    }
    setSubmitting(false)
  }

  // ! hide modal
  const hideModal = () => {
    setModal(false)
    setEdit(false)
    setAvatar()
    setInputData({
      username: '',
      company: '',
      description: '',
      status: false,
    })
    setTestimonialData()
  }

  return (
    <Modal show={isModal} size='md' centered onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Update' : 'Create'} Testimonial</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Form.Group as={Col} xs={12} className='mb-3' controlId='username'>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter username'
                name='username'
                value={inputData.username}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} className='mb-3' controlId='company'>
              <Form.Label>Company</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter company'
                name='company'
                value={inputData.company}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              className='mb-3'
              controlId='description'>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as='textarea'
                rows='5'
                name='description'
                value={inputData.description}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <DragDrop
              accept='image/*'
              name='avatar'
              files={avatar}
              setFiles={setAvatar}
              onChange={handleChange}
            />
          </Row>
          <Form.Switch
            label={inputData.status ? 'Visible' : 'Hidden'}
            id='status'
            name='status'
            checked={inputData.status}
            onChange={handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button type='submit' disabled={isSubmitting}>
            {isEdit ? 'Update' : 'Submit'}
            {isSubmitting && (
              <Spinner animation='border' size='sm' className='ms-2' />
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddTestimonial
